export default "__VITE_ASSET__3ec2e3c7__"